import { getAccessToken } from "./utils";
import { getUrl } from "./urls";
import axios from "axios";

import { toast } from "react-toastify";

export const FETCH_PUBLICATIONS_LIST = "FETCH_PUBLICATIONS_LIST";
export const ADD_PUBLICATIONS = "ADD_PUBLICATIONS";
export const DELETE_PUBLICATIONS = "DELETE_PUBLICATIONS";
export const FETCH_PUBLICATIONS_SUGGESTIONS = "FETCH_PUBLICATIONS_SUGGESTIONS";

export const fetchPublicationsList = () => {
    let url = `${getUrl("publication-service")}/list?section_name=3&entity_type=18&access-token=${getAccessToken()}`;
    let req = axios({
        method: "get",
        url,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // console.log(res);
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_PUBLICATIONS_LIST,
        payload: req,
    };
};

export const addPublications = (publication) => {
    let url = `${getUrl("publication-service")}/create?section_name=3&access-token=${getAccessToken()}`;
    let company_id = JSON.parse(localStorage.getItem("company")).company_id;
    let data = {
        section_name: 3,
        entity_type: 18,
        company_id,
        publication,
    };
    let req = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success(`${publication} is successfully added to Publications list`);
            return res.data;
        })
        .catch((err) => {
            console.log(err);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: ADD_PUBLICATIONS,
        payload: req,
    };
};

export const deletePublication = (publication) => {
    let url = `${getUrl("publication-service")}/${publication.id}?access-token=${getAccessToken()}`;

    let req = axios({
        method: "delete",
        url,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // console.log(res);
            toast.success(`${publication.entity_name} is successfully deleted from Publications list`);
            return res.data;
        })
        .catch((err) => {
            console.log(err);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: DELETE_PUBLICATIONS,
        payload: req,
    };
};

export const fetchPublicationsSuggestions = () => {
    let data = new URLSearchParams();
    data.append("secret_key", "Circ*3u$s1@4c!Ewe");
    data.append("tag_type", "Publication");
    let url = `https://api2.radarr.com/cassandra/get-tags`;
    let req = axios({
        method: "post",
        url: url,
        data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
    })
        .then((res) => {
            return res.data.map((d) => d.tag_name);
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_PUBLICATIONS_SUGGESTIONS,
        payload: req,
    };
};
